import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import InfiniteModeProInfo from "@/components/InfiniteModeProInfo";
import ProChip from "@/components/ProChip";
import { useGlobalStoreContext } from "@/context/globalStoreContext";
import useEvent from "@/hooks/useEvent";
import usePlatform from "@/hooks/usePlatform";

import { useAlertContext } from "../AlertContext";

interface MobileDrawerProps {
  children: React.ReactNode;
  open: boolean;
  onOpen: (value: boolean) => void;
  CreateButton: React.ReactNode;
  onShowTips: () => void;
}

const MobileDrawer = ({ open, onOpen, children, CreateButton, onShowTips }: MobileDrawerProps) => {
  const { isMobile } = usePlatform();
  const { infiniteMode, setInfiniteMode } = useAlertContext();

  const store = useGlobalStoreContext();

  const handleClose = useEvent(() => {
    onOpen(false);
  });

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { width: "100%", height: "100%" } }}
    >
      <div className="h-full overflow-hidden flex flex-col">
        <DialogTitle>
        <NotificationsActiveIcon sx={{ fontSize: 20, color: (theme) => theme.palette.primary.main }} />
          <Typography color="textPrimary">AwardTool Advanced Alert</Typography>
        </DialogTitle>

        <IconButton
          onClick={handleClose}
          className="!absolute !right-[8px] !top-[8px]"
          sx={{ color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers className="!pt-[10px] !px-[16px] overflow-auto">
          {children}
        </DialogContent>

        <DialogActions>
          <div className="flex justify-between w-[100%]">
            <div className="flex flex-wrap items-center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={infiniteMode}
                    onChange={(_, checked) => {
                      if (store.show_upsell) {
                        onShowTips?.();
                        return;
                      }
                      setInfiniteMode(checked);
                    }}
                  />
                }
                label={
                  <div className="flex items-center">
                    <span>{isMobile ? "Infinite" : "Infinite mode"}</span>
                    <ProChip />
                  </div>
                }
              />
              <Tooltip sx={{ size: 10 }} title={<InfiniteModeProInfo />}>
                <InfoOutlinedIcon sx={{ fontSize: 16, margin: "auto", ml: -1 }} />
              </Tooltip>
            </div>
            <div>
              <Button onClick={handleClose}>Cancel</Button>
              {CreateButton}
            </div>
          </div>
        </DialogActions>
      </div>
    </Drawer>
  );
};

export default React.memo(MobileDrawer);
